import { EVENT_CONFIG } from "@/config/eventConfig";
import { SectionHeading, Reveal, CountUp } from "./shared";

const Mission = () => {
  const { org, impact, programs, images } = EVENT_CONFIG;

  return (
    <section id="mission" data-testid="mission-section" className="relative py-24 sm:py-32 bg-ink grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="flex flex-col gap-7">
            <SectionHeading
              align="left"
              chapter="02"
              eyebrow="The Mission"
              title={
                <>
                  WHY WE BUILD <span className="gold-shimmer">CROWNS</span>
                </>
              }
            />
            <Reveal delay={0.1}>
              <p className="text-cream text-base sm:text-lg leading-relaxed">{org.mission}</p>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="text-cream/80 text-base leading-relaxed">
                For children in foster care and in transracial adoptive or biracial families, textured-hair
                care is about far more than style. It is confidence. It is identity. It is cultural connection.
                Styles 4 Kidz equips children, parents and caregivers with the tools, knowledge and
                culturally responsive care every crown deserves — at salons, in workshops, and at home.
              </p>
            </Reveal>
            <Reveal delay={0.26} className="flex flex-wrap gap-2.5">
              {programs.map((p) => (
                <span
                  key={p}
                  className="px-4 py-2 rounded-full border border-champagne/25 text-champagne/90 text-[11px] uppercase tracking-[0.18em]"
                >
                  {p}
                </span>
              ))}
            </Reveal>
          </div>

          <Reveal delay={0.15} className="relative">
            <div className="grid grid-cols-2 gap-4">
              <img
                src={images.childBraids}
                alt="Child with beautifully styled natural hair"
                loading="lazy"
                className="rounded-2xl object-cover h-64 sm:h-80 w-full gold-stroke"
              />
              <img
                src={images.s4kHaircare}
                alt="Stylist caring for a child's textured hair at the Styles 4 Kidz salon"
                loading="lazy"
                className="rounded-2xl object-cover h-64 sm:h-80 w-full mt-10 gold-stroke"
              />
            </div>
            <img
              src={images.speech}
              alt="Styles 4 Kidz gala program moment"
              loading="lazy"
              className="absolute -bottom-10 left-1/2 -translate-x-1/2 w-56 sm:w-72 rounded-2xl gold-stroke shadow-[0_25px_60px_-15px_rgba(0,0,0,0.8)] hidden sm:block"
            />
          </Reveal>
        </div>

        <div className="mt-24 sm:mt-32">
          <Reveal>
            <p className="text-center text-xs uppercase tracking-[0.4em] text-gold mb-10">The Impact</p>
          </Reveal>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
            {impact.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.08}>
                <div
                  data-testid={`impact-stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="relative rounded-2xl bg-gradient-to-b from-oxblood to-coal gold-stroke p-6 sm:p-9 text-center overflow-hidden"
                >
                  <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-champagne to-transparent" />
                  <div className="font-serif text-3xl sm:text-5xl gold-text">
                    <CountUp value={s.value} suffix={s.suffix} />
                  </div>
                  <div className="mt-3 text-[10px] sm:text-xs uppercase tracking-[0.25em] text-cream/70">
                    {s.label}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
